export enum CalendarPlatform {
  GOOGLE = "google_calendar",
  MICROSOFT = "microsoft_outlook",
}

export type Calendar = {
  id: string;
  userId: string;
  platform: CalendarPlatform;
  externalId: string;
  connectionData: string;
};
